// import { BodyEncryption, axiosClient } from "@/app/apibinding/apiClient";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const WorkFlowGetList = createAsyncThunk(
    "WorkFlowGetList",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.WORKFLOWGETLIST,
                    body: data,
                },
                true
            );
            let response = apiResponse(false, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);

export const WorkFlowSave = createAsyncThunk(
    "WorkFlowSave",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.WORKFLOWSAVE,
                    body: data,
                },
                true
            );
            let response = apiResponse(true, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);

export const GetWorkFlowByID = createAsyncThunk(
    "GetWorkFlowByID",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.GET_WORKFLOW_DETAIL_BY_ID,
                    body: data,
                },
                true
            );
            let response = apiResponse(false, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);

export const GetWorkspaceListByID = createAsyncThunk(
    "GetWorkspaceListByID",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "GET",
                    url: `${API_URL.BASEURL + API_URL.GET_WORKSPACE_LIST_BY_ID
                        }?associationid=${data}&associationtype=workflow`,
                    // body: data,
                },
                false
            );
            let response = apiResponse(false, resData?.value);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);

export const GetWorkCronExpression = createAsyncThunk(
    "GetWorkCronExpression",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.GET_WORKFLOW_CRON_EXPRESSION,
                    body: data,
                },
                true
            );
            let response = apiResponse(true, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);

export const RunWorkFlow = createAsyncThunk(
    "RunWorkFlow",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.WORKFLOWRUNWORKFLOW,
                    body: data,
                },
                true
            );
            let response = apiResponse(false, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);

export const GetCurrentWorkFlow = createAsyncThunk(
    "GetCurrentWorkFlow",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "GET",
                    url: `${API_URL.BASEURL + API_URL.WORKFLOW.GET_CURRENT_WORKFLOW
                        }?machineId=${data}`,
                    // body: data,
                },
                false
            );
            let response = apiResponse(false, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);

export const GetDashBoardWorkFlowList = createAsyncThunk(
    "GetDashBoardWorkFlowList",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "GET",
                    url:
                        API_URL.BASEURL +
                        API_URL.WORKFLOW.GET_DASHBOARD_LIST +
                        `?recordLimit=${data?.limit}&searchText=${data?.searchText}`,
                },
                false
            );
            let response = apiResponse(false, resData);

            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);
export const WorkFlowCopy = createAsyncThunk(
    "WorkFlowCopy",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.WORKFLOWCOPY,
                    body: data,
                },
                true
            );
            let response = apiResponse(true, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);
export const UpdateWorkFlowStatus = createAsyncThunk(
    "UpdateWorkFlowStatus",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.WORKFLOW.UPDATE_WORKFLOW_STATUS,
                    body: data,
                },
                true
            );
            let response = apiResponse(true, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);
export const UpdateWorkFlowRunningStatus = createAsyncThunk(
    "UpdateWorkFlowRunningStatus",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASEURL + API_URL.WORKFLOW.UPDATE_WORKFLOW_RUNNING_STATUS,
                    body: data,
                },
                true
            );
            let response = apiResponse(true, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);
export const GetWorkflowScheduleDetails = createAsyncThunk(
    "GetWorkflowScheduleDetails",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.WORKFLOW.GET_WORKFLOW_SCHEDULE_DETAIL,
                    body: data,
                },
                true
            );
            let response = apiResponse(false, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);
export const GetScheduleList = createAsyncThunk(
    "GetScheduleList",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.WORKFLOW.GET_SCHEDULE_LIST,
                    body: data,
                },
                true
            );
            let response = apiResponse(false, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);
export const UpdateDescription = createAsyncThunk(
    "UpdateDescription",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.WORKFLOW.UPDATE_WORKFLOW_DESCRIPTION,
                    body: data,
                },
                true
            );
            let response = apiResponse(true, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);
export const SaveWorkflowPrompt = createAsyncThunk(
    "SaveWorkflowPrompt",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.WORKFLOW.SAVE_WORKFLOW_PROMPT,
                    body: data,
                },
                true
            );
            let response = apiResponse(false, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);

export const GetWorkflowPrompt = createAsyncThunk(
    "GetWorkflowPrompt",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "GET",
                    url:
                        API_URL.BASEURL +
                        API_URL.WORKFLOW.GET_WORKFLOW_PROMPT +
                        `?workflowid=${data}`,
                },
                false
            );
            let response = apiResponse(false, resData);

            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);

export const GetWorkflowStatistics = createAsyncThunk(
    "GetWorkflowStatistics",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "GET",
                    url:
                        API_URL.BASEURL +
                        API_URL.WORKFLOW.GET_WORKFLOW_STATISTICS +
                        `?timezone=${data?.timezone}&startdate=${data?.startdate}`,
                },
                false
            );
            let response = apiResponse(false, resData);

            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);

export const GetDashboardTodayWorkflowStatisticsCount = createAsyncThunk(
    "GetDashboardTodayWorkflowStatisticsCount",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "GET",
                    url:
                        API_URL.BASEURL +
                        API_URL.WORKFLOW.GET_DASHBOARD_TODAY_WORKFLOW_STATISTICS_COUNT +
                        `?currentdate=${data?.currentdate}&timezone=${data?.timezone}`,
                },
                false
            );
            let response = apiResponse(false, resData);

            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);

export const GetMachineWiseCostList = createAsyncThunk(
    "GetMachineWiseCostList",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "GET",
                    url:
                        API_URL.BASEURL +
                        API_URL.WORKFLOW.GET_MACHINE_WISE_COST_LIST +
                        `?workflowid=${data.workflowid}&timezone=${data?.timezone}`,
                },
                false
            );
            let response = apiResponse(false, resData);

            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);
export const WorkflowTagSearch = createAsyncThunk(
    "WorkflowTagSearch",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "GET",
                    url:
                        API_URL.BASEURL +
                        API_URL.WORKFLOW.GET_WORKFLOW_TAG_SEARCH_LIST +
                        `?search=${data.search}`,
                },
                false
            );
            let response = apiResponse(false, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);


export const WorkFlowTimeLineList = createAsyncThunk(
    "WorkFlowTimeLineList",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.GETWORKFLOWTIMELINE,
                    body: data,
                },
                true
            );
            let response = apiResponse(false, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);

export const WorkflowGetListForDDL = createAsyncThunk(
    "WorkflowGetListForDDL",
    async (data, { dispatch }) => {
        try {
            dispatch(setLoader(true));
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.WORKFLOWGETLISTFORDDL,
                    body: data,
                },
                true
            );
            let response = apiResponse(false, resData);
            dispatch(setLoader(false));
            return response;
        } catch (error) {
            dispatch(setLoader(false));
        }
    }
);


const initialState = {
    WorkFlowGetListData: {
        data: null,
        error: null,
    },
    WorkflowGetListForDDLData: {
        data: null,
        error: null,
    },
    WorkFlowTimeLineListData: {
        data: null,
        error: null,
    },
    WorkFlowSaveData: {
        data: null,
        error: null,
    },
    GetWorkFlowByIDData: {
        data: null,
        error: null,
    },
    GetWorkCronExpressionData: {
        data: null,
        error: null,
    },
    RunWorkFlowData: {
        data: null,
        error: null,
    },
    GetCurrentWorkFlowData: {
        data: null,
        error: null,
    },
    GetDashBoardWorkFlowListData: {
        data: null,
        error: null,
    },
    WorkFlowCopyData: {
        data: null,
        error: null,
    },
    UpdateWorkFlowStatusData: {
        data: null,
        error: null,
    },
    UpdateWorkFlowRunningStatusData: {
        data: null,
        error: null,
    },
    GetWorkflowScheduleDetailsData: {
        data: null,
        error: null,
    },
    GetScheduleListData: {
        data: null,
        error: null,
    },
    UpdateDescriptionData: {
        data: null,
        error: null,
    },
    SaveWorkflowPromptData: {
        data: null,
        error: null,
    },
    GetWorkflowPromptData: {
        data: null,
        error: null,
    },
    GetWorkflowStatistics: {
        data: null,
        error: null,
    },
    GetDashboardTodayWorkflowStatisticsCount: {
        data: null,
        error: null,
    },
    GetMachineWiseCostList: {
        data: null,
        error: null,
    },
    WorkflowTagSearch: {
        data: null,
        error: null,
    }
};

const WorkFlowSlice = createSlice({
    name: "WORKFLOW",
    initialState,
    reducers: {
        setLoader: (state, action) => {
            state.isLoading = action.payload;
        },
        setWorkFlowGetListData: (state) => {
            state.WorkFlowGetListData.data = null;
        },
        setWorkFlowTimeLineListData: (state) => {
            state.WorkFlowTimeLineListData.data = null;
        },
        setGetWorkFlowByID: (state) => {
            state.GetWorkFlowByIDData.data = null;
        },
        setGetWorkflowScheduleDetails: (state) => {
            state.GetWorkflowScheduleDetailsData.data = null;
        },

    },



    extraReducers: (builder) => {
        builder
            .addCase(WorkFlowGetList.fulfilled, (state, action) => {
                state.WorkFlowGetListData.data = action.payload;
            })
            .addCase(WorkFlowGetList.rejected, (state, action) => {
                state.WorkFlowGetListData.error = action.error.message;
            })

            .addCase(WorkflowGetListForDDL.fulfilled, (state, action) => {
                state.WorkflowGetListForDDLData.data = action.payload;
            })
            .addCase(WorkflowGetListForDDL.rejected, (state, action) => {
                state.WorkflowGetListForDDLData.error = action.error.message;
            })

        
            .addCase(WorkFlowTimeLineList.fulfilled, (state, action) => {
                state.WorkFlowTimeLineListData.data = action.payload;
            })
            .addCase(WorkFlowTimeLineList.rejected, (state, action) => {
                state.WorkFlowTimeLineListData.error = action.error.message;
            })
            .addCase(WorkFlowSave.fulfilled, (state, action) => {
                state.WorkFlowSaveData.data = action.payload;
            })
            .addCase(WorkFlowSave.rejected, (state, action) => {
                state.WorkFlowSaveData.error = action.error.message;
            })
            .addCase(GetWorkFlowByID.fulfilled, (state, action) => {
                state.GetWorkFlowByIDData.data = action.payload;
            })
            .addCase(GetWorkFlowByID.rejected, (state, action) => {
                state.GetWorkFlowByIDData.error = action.error.message;
            })
            .addCase(GetWorkspaceListByID.fulfilled, (state, action) => {
                state.GetWorkFlowByIDData.data = action.payload;
            })
            .addCase(GetWorkspaceListByID.rejected, (state, action) => {
                state.GetWorkFlowByIDData.error = action.error.message;
            })
            .addCase(GetWorkCronExpression.fulfilled, (state, action) => {
                state.GetWorkCronExpressionData.data = action.payload;
            })
            .addCase(GetWorkCronExpression.rejected, (state, action) => {
                state.GetWorkCronExpressionData.error = action.error.message;
            })
            .addCase(RunWorkFlow.fulfilled, (state, action) => {
                state.RunWorkFlowData.data = action.payload;
            })
            .addCase(RunWorkFlow.rejected, (state, action) => {
                state.RunWorkFlowData.error = action.error.message;
            })
            .addCase(GetCurrentWorkFlow.fulfilled, (state, action) => {
                state.GetCurrentWorkFlowData.data = action.payload;
            })
            .addCase(GetCurrentWorkFlow.rejected, (state, action) => {
                state.GetCurrentWorkFlowData.error = action.error.message;
            })
            .addCase(GetDashBoardWorkFlowList.fulfilled, (state, action) => {
                state.GetDashBoardWorkFlowListData.data = action.payload;
            })
            .addCase(GetDashBoardWorkFlowList.rejected, (state, action) => {
                state.GetDashBoardWorkFlowListData.error = action.error.message;
            })
            .addCase(WorkFlowCopy.fulfilled, (state, action) => {
                state.WorkFlowCopyData.data = action.payload;
            })
            .addCase(WorkFlowCopy.rejected, (state, action) => {
                state.WorkFlowCopyData.error = action.error.message;
            })
            .addCase(UpdateWorkFlowStatus.fulfilled, (state, action) => {
                state.UpdateWorkFlowStatusData.data = action.payload;
            })
            .addCase(UpdateWorkFlowStatus.rejected, (state, action) => {
                state.UpdateWorkFlowStatusData.error = action.error.message;
            })
            .addCase(UpdateWorkFlowRunningStatus.fulfilled, (state, action) => {
                state.UpdateWorkFlowRunningStatusData.data = action.payload;
            })
            .addCase(UpdateWorkFlowRunningStatus.rejected, (state, action) => {
                state.UpdateWorkFlowRunningStatusData.error = action.error.message;
            })
            .addCase(GetWorkflowScheduleDetails.fulfilled, (state, action) => {
                state.GetWorkflowScheduleDetailsData.data = action.payload;
            })
            .addCase(GetWorkflowScheduleDetails.rejected, (state, action) => {
                state.GetWorkflowScheduleDetailsData.error = action.error.message;
            })
            .addCase(GetScheduleList.fulfilled, (state, action) => {
                state.GetScheduleListData.data = action.payload;
            })
            .addCase(GetScheduleList.rejected, (state, action) => {
                state.GetScheduleListData.error = action.error.message;
            })
            .addCase(UpdateDescription.fulfilled, (state, action) => {
                state.UpdateDescriptionData.data = action.payload;
            })
            .addCase(UpdateDescription.rejected, (state, action) => {
                state.UpdateDescriptionData.error = action.error.message;
            })
            .addCase(SaveWorkflowPrompt.fulfilled, (state, action) => {
                state.SaveWorkflowPromptData.data = action.payload;
            })
            .addCase(SaveWorkflowPrompt.rejected, (state, action) => {
                state.SaveWorkflowPromptData.error = action.error.message;
            })
            .addCase(GetWorkflowPrompt.fulfilled, (state, action) => {
                state.GetWorkflowPromptData.data = action.payload;
            })
            .addCase(GetWorkflowPrompt.rejected, (state, action) => {
                state.GetWorkflowPromptData.error = action.error.message;
            })
            .addCase(GetWorkflowStatistics.fulfilled, (state, action) => {
                state.GetWorkflowStatistics.data = action.payload;
            })
            .addCase(GetWorkflowStatistics.rejected, (state, action) => {
                state.GetWorkflowStatistics.error = action.error.message;
            })
            .addCase(GetDashboardTodayWorkflowStatisticsCount.fulfilled, (state, action) => {
                state.GetDashboardTodayWorkflowStatisticsCount.data = action.payload;
            })
            .addCase(GetDashboardTodayWorkflowStatisticsCount.rejected, (state, action) => {
                state.GetDashboardTodayWorkflowStatisticsCount.error = action.error.message;
            })
            .addCase(GetMachineWiseCostList.fulfilled, (state, action) => {
                state.GetMachineWiseCostList.data = action.payload;
            })
            .addCase(GetMachineWiseCostList.rejected, (state, action) => {
                state.GetMachineWiseCostList.error = action.error.message;
            })
            .addCase(WorkflowTagSearch.fulfilled, (state, action) => {
                state.WorkflowTagSearch.data = action.payload
            })
            .addCase(WorkflowTagSearch.rejected, (state, action) => {
                state.WorkflowTagSearch.error = action.error.message
            });
    },
});

export const {
    setLoader,
    setWorkFlowGetListData,
    setGetWorkFlowByID,
    setGetWorkflowScheduleDetails,
    setWorkFlowTimeLineListData,

} = WorkFlowSlice.actions;
export default WorkFlowSlice.reducer;
